import {Component, Input, OnInit} from "@angular/core";
import {ConfirmComponent} from "../../../dialogs/confirm/confirm.component";
import {MatDialog, MatDialogRef} from "@angular/material";
import {NotificationService} from "../../../services/notification.service";
import {Project} from "../../../services/model/projects.model";
import {ProjectService} from "../../../services/project.service";
import {environment} from "../../../../environments/environment";
import {ActivatedRoute} from "@angular/router";
import {ThirdPartyDialogComponent} from "../../../dialogs/third-party/third-party-dialog.component";

@Component({
    selector: 'app-third-party',
    templateUrl: './third-party.component.html',
})
export class ThirdPartyComponent implements OnInit{
    items: any;
    id: string;
    env = environment;
    dialogRef: MatDialogRef<ConfirmComponent>;
    editRef: MatDialogRef<ThirdPartyDialogComponent>;
    @Input('project') project: Project;

    constructor(
        private projectServ: ProjectService,
        private activeR: ActivatedRoute,
        public dialog: MatDialog,
        private notifServ: NotificationService,
    ){
        this.id = this.activeR.snapshot.params['id'];
    }

    ngOnInit(){

        this.items = this.projectServ.getProjectThirdParties(this.id).map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Project;
                const key = a.payload.doc.id;
                return { key, ...data };
            });
        });

    }

    editItem(status: boolean, item?: any){
        this.editRef = this.dialog.open(ThirdPartyDialogComponent, {width: this.env.dialogs.width});
        this.editRef.componentInstance.item = status ? item : {};
        this.editRef.componentInstance.id = this.id;
        this.editRef.componentInstance.is_new = !status;

        this.editRef.afterClosed().subscribe(result => {
            // TODO make sure the model does not change the old values
            if(result) {
            } else {
            }
        });
    }

    deleteThirdParty(key: string){
        this.projectServ.deletethirdParty(this.id, key).then(
            r => {
                this.notifServ.sendSuccess( '3rd party entry has been deleted');
            }
        )
    }


    openDelete(key: any){
        this.dialogRef = this.dialog.open(ConfirmComponent, {});
        this.dialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete "' + key.name + '" data?';

        this.dialogRef.afterClosed().subscribe(result => {
            if(result) {
                this.deleteThirdParty(key.key);
            } else {
            }
        });
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/3rd-party/third-party.component.ts